import { z } from 'zod';

/**
 * Base schema for check-in (without refinements)
 */
const CheckInBaseSchema = z.object({
  checkInDate: z.instanceof(Date).optional(),
  previousValue: z.number().finite('O valor anterior deve ser um número finito'),
  newValue: z.number().finite('O novo valor deve ser um número finito'),
  progressChange: z.number().finite('A mudança de progresso deve ser um número finito'),
  impediments: z.string().max(1000, 'Os impedimentos devem ter no máximo 1000 caracteres').optional(),
  notes: z.string().max(2000, 'As observações devem ter no máximo 2000 caracteres').optional(),
  actionsRequired: z.string().max(1000, 'As ações necessárias devem ter no máximo 1000 caracteres').optional(),
  recordedById: z.string().min(1, 'O ID do responsável pelo registro é obrigatório'),
  recordedByName: z.string().min(1, 'O nome do responsável pelo registro é obrigatório'),
  recordedByEmail: z.string().email('Formato de e-mail inválido'),
  cycleEventId: z.string().nullable().optional()
});

/**
 * Zod schema para criação de um novo check-in.
 * Check-ins são imutáveis após criação, não há schema de atualização.
 */
export const CheckInCreateSchema = CheckInBaseSchema.refine(
  (data) => data.previousValue !== data.newValue,
  {
    message: 'O novo valor deve ser diferente do valor anterior',
    path: ['newValue']
  }
);

export type CheckInCreate = z.infer<typeof CheckInCreateSchema>;

/**
 * Schema Zod completo para entidade check-in com todos os campos
 */
export const CheckInSchema = CheckInBaseSchema.extend({
  id: z.string().min(1, 'O ID do check-in é obrigatório'),
  checkInDate: z.instanceof(Date),
  createdAt: z.instanceof(Date)
});

export type CheckIn = z.infer<typeof CheckInSchema>;
